// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1_hpp","label":"Section_label__13fPq","contentWrap":"Section_contentWrap__19tb9","footer":"Section_footer__3t2RV","footerInner":"Section_footerInner__1ccQw"};